import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  gatewayId: number | string;
  targetInstallationId: number | string;
  currentInstallationId: number | string;
}

export function useMoveGateway() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ projectId, gatewayId, targetInstallationId }: Params) =>
      post({
        url: `/projects/${projectId}/gateways/${gatewayId}/move`,
        body: {
          installationId: Number(targetInstallationId),
        },
      }),
    onSuccess: (_, { projectId, currentInstallationId, targetInstallationId }) => {
      const invalidateInstallation = (installationId: number | string) => {
        queryClient.invalidateQueries({
          queryKey: queryKeys.getGateways(projectId, installationId.toString()),
        });
      };

      invalidateInstallation(currentInstallationId);
      invalidateInstallation(targetInstallationId);

      queryClient.invalidateQueries({
        queryKey: queryKeys.getGateways(projectId, 'installationId'),
      });
    },
  });

  const moveGateway = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    moveGateway,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
